export const notifications = {
	export: {
		successNotification: "Productos exportados a Excel",
		errorNotification: "Error al exportar productos a Excel",
	},
	productToggle: {
		successActivated: "El producto {{productName}} fue activado exitosamente",
		successDeactivated: "El producto {{productName}} fue desactivado exitosamente",
	},
	massActions: {
		successActivated: "Productos activados exitosamente",
		successDeactivated: "Productos desactivados exitosamente",
		successEdited: "Productos editados exitosamente",
		errorEdited: "Error al editar productos",
		noChanges: "Seleccione al menos un campo para guardar los cambios",
	},
	categoryNotFound:
		"Categoría no encontrada. Redirigiendo a la primera categoría disponible.",
};
